import App from './App.tsx'
import '@/styles/globals.css'
import { Toaster } from 'sonner'
import { Provider } from 'react-redux'
import { store } from '@/store/store.ts'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'   // <-- use @posthog/react
import { ImageProvider } from './context/ImageContext.tsx'
import posthog from './lib/posthog' // our initializer file

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <PostHogProvider client={posthog}>
      <ImageProvider>
        <App />
        <Toaster richColors expand position="top-center" theme="dark" />
      </ImageProvider>
    </PostHogProvider>
  </Provider>
)
